import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type KnowledgeDashboard, type QualityMetrics } from '../../api/knowledge';

export function KnowledgeAnalyticsPage() {
  const [dashboard, setDashboard] = useState<KnowledgeDashboard | null>(null);
  const [quality, setQuality] = useState<QualityMetrics | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void Promise.all([knowledgeApi.dashboard(), knowledgeApi.quality()])
      .then(([d, q]) => { setDashboard(d); setQuality(q); })
      .catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/knowledge" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Knowledge Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Knowledge Analytics</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard && quality && (
        <div className="mt-6 grid gap-4 sm:grid-cols-2">
          <MetricCard label="Embeddings Indexed" value={dashboard.embeddings_indexed} />
          <MetricCard label="Searches (24h)" value={dashboard.searches_24h} />
          <MetricCard label="Freshness" value={`${(quality.freshness * 100).toFixed(0)}%`} />
          <MetricCard label="Completeness" value={`${(quality.completeness * 100).toFixed(0)}%`} />
          <MetricCard label="Coverage" value={`${(quality.coverage * 100).toFixed(0)}%`} />
          <MetricCard label="Conflicts" value={quality.conflicts} />
        </div>
      )}
    </div>
  );
}

function MetricCard({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
      <p className="text-sm text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold">{value}</p>
    </div>
  );
}
